var _path, _circle, _path2, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedalBronze(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.31334 19.7917H31.8776V38.734C31.8776 40.1694 30.4582 41.1735 29.1047 40.6955L20.0955 37.5142L11.0863 40.6955C9.73277 41.1735 8.31334 40.1694 8.31334 38.734V19.7917Z",
    fill: "#D7975D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0943,
    cy: 20.4196,
    r: 14.4004,
    transform: "rotate(35.6401 20.0943 20.4196)",
    fill: "#E5AE7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7036 32.1227C18.167 36.757 27.1634 35.2741 31.7977 28.8106L8.39147 12.0287C3.75725 18.4921 5.24013 27.4885 11.7036 32.1227Z",
    fill: "#F7BE8B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0942,
    cy: 20.4195,
    r: 12.9004,
    transform: "rotate(35.6401 20.0942 20.4195)",
    stroke: "#D7975D",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalBronze);
export default __webpack_public_path__ + "static/media/medal-bronze.061d2a77d0b94695f966a9fe14f6fe82.svg";
export { ForwardRef as ReactComponent };